import { gql } from '@apollo/client';

import USER_PROFILE_DETAILS_FRAGMENT from '../fragments/user-profile-details';

export default gql`
  mutation updateMeMutation($data: UserUpdateInput!) {
    updateMe(data: $data) {
      ...BaseUserProfileDetails
    }
  }
  ${USER_PROFILE_DETAILS_FRAGMENT}
`;
